import React from 'react';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import Reaction
  from 'Components/ComponentLibrary/Components/Uncategorized/ReactionList/components/ReactionItem/Reaction';
import {
  ReactionTooltip,
} from 'Components/ComponentLibrary/Components/Uncategorized/ReactionList/components/ReactionItem/components/ReactionTooltip';
import { DataValueMap } from 'Helpers/Testing';

const ReactionItem = ({
  reaction, onAddReaction, onRemoveReaction,
}) => {
  return (
    <Reaction
      tooltip={<ReactionTooltip emoji={reaction.emoji} owners={reaction.owners} />}
      emoji={reaction.emoji}
      handleAdd={() => onAddReaction()}
      handleRemove={() => onRemoveReaction()}
      count={reaction.count}
      isMyEmoji={reaction.isSelected}
      {...DataValueMap.init(`reaction-${reaction.emoji.replaceAll(/[^0-9A-Za-z \-_]/g, '')}`)
        .append(DataValueMap.keyMap.dataValue, reaction.count.toString())
        .build()}
    />
  );
};

ReactionItem.defaultProps = {
  onAddReaction: noop,
  onRemoveReaction: noop,
};
ReactionItem.propTypes = {
  // reaction: A reaction object
  reaction: PropTypes.object.isRequired,
  // onAddReaction: callback to run if a reaction is added
  onAddReaction: PropTypes.func,
  // onRemoveReaction: callback to run if a reaction is removed
  onRemoveReaction: PropTypes.func,
};
export { ReactionItem };
